export default __webpack_public_path__ + "static/blue-8bc7c6d534104d337a7d1a14f35b5988.mp3";